import { OwnerSelect } from 'src/components/owner-select';

export default OwnerSelect;
